export const sanitiser = (amount: string, minimum: number, maximum: number): string => {
  let tempAmount = !amount ? minimum : Number(amount);

  if (tempAmount < minimum) {
    tempAmount = minimum;
  }

  if (tempAmount > maximum) {
    tempAmount = maximum;
  }

  return `${Math.round(tempAmount / 100) * 100}`;
};
